import { Box, forwardRef, StyleProps } from '@bonusly/design-system';

interface SelectorOptionProps extends StyleProps {
	isSelected?: boolean;
}

export const SelectorOption = forwardRef(({ isSelected = false, ...rest }: SelectorOptionProps, ref) => {
	return (
		<Box
			_focus={{ backgroundColor: 'secondary.bgAlpha' }}
			_hover={{ backgroundColor: 'secondary.bgAlpha' }}
			as="button"
			border={0}
			borderColor="gray.50"
			borderRadius="sm"
			borderStyle="solid"
			cursor="pointer"
			listStyleType="none"
			p={2}
			ref={ref}
			role="option"
			tabIndex={0}
			transitionDuration="normal"
			transitionProperty="common"
			w="full"
			sx={{
				'&[data-focus="true"]': {
					backgroundColor: 'secondary.bgAlpha',
				},
			}}
			{...(isSelected && {
				'data-focus': true,
			})}
			{...rest}
		/>
	);
});
